import { z } from "zod";
export const isoDateTimeSchema = z.string().datetime({ offset: true });
/**
 * Public profile stored at `users/{uid}`.
 *
 * The client may only update the fields listed in USER_PROFILE_EDITABLE_FIELDS;
 * everything else is backend-written. See `firebase/firestore.rules`.
 */
export const userProfileSchema = z.object({
    uid: z.string().min(1),
    email: z.string().email().nullable(),
    displayName: z.string().min(1).max(120).nullable(),
    photoUrl: z.string().url().nullable(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const USER_PROFILE_EDITABLE_FIELDS = ["displayName", "photoUrl"];
export const userProfileUpdateSchema = z
    .object({
    displayName: z.string().min(1).max(120).nullable(),
    photoUrl: z.string().url().nullable(),
})
    .partial()
    .strict();
//# sourceMappingURL=profile.js.map